import {Controller} from '@hotwired/stimulus';

export default class extends Controller {
    toggle(event) {
        event.preventDefault();
        const isOpen = this.element.classList.toggle('is-open');
        event.currentTarget.setAttribute('aria-expanded', isOpen);
    }
}
